export enum UserAgents {
    TEAMS = 305
}

export enum UserAgentsHeader {
    TEAMS_HEADER = 'Teams'
}
